import _ from "lodash";
import ls from "local-storage";
import Axios from 'axios';

const saveStatementsSmartList = async customs => {
    try {
        await Axios.post('/userclientconfigurations', {
            Name: 'statement-smart-list',
            JsonData: JSON.stringify({
                smartList: customs
            })
        });
    } catch (error) {
        console.error('Save Statements Smart List Error => ', error);
    }
};

const StatementFiltersReducer = (state, action) => {
    switch (action.type) {
        case "StatementFiltersChangeActiveSet":
            ls.set("nw_config_statementwallfilter", {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            });
            return {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            };
        case "StatementFiltersAddCustomSet":
            const customSetCopy = Array.isArray(state.customSets) ? [...state.customSets] : [];
            customSetCopy.push(action.newSet);
            const data = {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            }
            ls.set("nw_config_statementwallfilter", data);
            let smartList = [...data.customSets];
            saveStatementsSmartList(smartList);
            return {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            };
        case "StatementFiltersEditCustomSet":
            let customSetCopy2 = state.customSets.filter(
                el => el.id !== action.newSet.id
            );
            action.newSet.id = Date.now();
            customSetCopy2.push(action.newSet);
            const editData = {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };
            ls.set("nw_config_statementwallfilter", editData);
            let editSmartList = editData.customSets
            saveStatementsSmartList(editSmartList);
            return {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };
        case "StatementFiltersCloneSet":
            const copyOfActive = _.cloneDeep(action.activeSet);
            copyOfActive.id = Date.now();
            copyOfActive.fixed = false;
            copyOfActive.name = copyOfActive.name + "(copy)";
            const copyOfCustomSets = [...state.customSets];
            copyOfCustomSets.push(copyOfActive);
            const cloneData = {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };
            ls.set("nw_config_statementwallfilter", cloneData);
            let cloneSmartList = [...cloneData.customSets];
            saveStatementsSmartList(cloneSmartList);
            return {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };
        case "StatementFiltersDeleteSet":
            const newCustomSets = [...state.customSets].filter(
                el => el.id !== action.activeSet
            );
            const deleteData = {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v0'
            };
            ls.set("nw_config_statementwallfilter", deleteData);
            let deleteSmartList = [...deleteData.customSets];
            saveStatementsSmartList(deleteSmartList);
            return {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v0'
            };
        case "StatementSaveCustomSets":
            let newFilterData = { ...state, customSets: action.customSets };

            ls.set("nw_config_statementwallfilter", newFilterData);
            return newFilterData;
        default:
            return state;
    }
};

export default StatementFiltersReducer;
